<template>
  <div v-if="hasSavings" class="Cart__Savings">
    <p class="t5">{{ message }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { formattedPrice } from '@utils/price-helpers';

const props = defineProps({
  subtotal: Number,
  originalSubtotal: Number,
});

const hasSavings = computed(
  () => props?.originalSubtotal - props?.subtotal > 0
);
const message = computed(() => {
  const amount = formattedPrice(
    ((props?.originalSubtotal - props?.subtotal) / 100).toFixed(2)
  );
  return `You saved ${amount}!`;
});
</script>
